import React from 'react';

import { bemBlock } from '../../modules/bem';

import { useTableContext } from './TableContext';

import './TableHead.less';

const block = bemBlock('table-head');

export type TableHeadProps = React.HTMLAttributes<HTMLTableSectionElement> & {
  sticky?: boolean;
  withBorderRadius?: boolean;
};

export const TableHead = React.forwardRef<HTMLTableSectionElement, TableHeadProps>(
  function TableHead({ className, withBorderRadius = true, sticky = false, ...passProps }, ref) {
    const { shouldVirtualize } = useTableContext();

    return (
      <thead
        ref={ref}
        className={block({
          modifiers: { withBorderRadius, sticky, virtualized: shouldVirtualize },
          extra: className,
        })}
        {...passProps}
      />
    );
  },
);
